import { cn } from "cn";
import { type PropsWithChildren, useEffect, useState } from "react";
import { ThemeToggle } from "@/components/theme-toggle";
import { BwLogoWithText } from "../../icons";

export const PublicHeader = ({ children }: PropsWithChildren) => {
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 0;
      setHasScrolled(scrolled);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={cn(
        /* sorted */
        "sticky top-0 z-10 flex items-center justify-between",
        "h-16",
        "px-3 py-4",
        "bg-bg-light",
        "xl:px-6",
        {
          "border-b border-b-border-dark-low": hasScrolled,
        },
      )}
    >
      <BwLogoWithText height={32} />
      <div className="flex items-center gap-2">
        <ThemeToggle />
        {children}
      </div>
    </header>
  );
};

export default PublicHeader;
